import project_1 from '../assets/project/pf_1.png'
import project_2 from '../assets/project/pf_2.png'
import project_3 from '../assets/project/pf_3.png'
import project_4 from '../assets/project/pf_4.png'
import project_5 from '../assets/project/pf_5.png'
import project_6 from '../assets/project/pf_6.png'
import project_7 from '../assets/project/pf_7.png'
import project_8 from '../assets/project/pf_8.png'
import project_9 from '../assets/project/pf_9.png'
import project_10 from '../assets/project/pf_10.png'
import project_11 from '../assets/project/pf_11.png'
import project_12 from '../assets/project/pf_12.png'

import award_1 from '../assets/images/awards/aw-1.png'
import award_2 from '../assets/images/awards/aw-2.png'
import award_3 from '../assets/images/awards/aw-3.png'
import award_4 from '../assets/images/awards/aw-4.png'

import kartik from '../assets/images/testmonial/kartik.png'
import sonalmehra from '../assets/images/testmonial/sonalmehra.png'
import pooja from '../assets/images/testmonial/pooja.png'
import jayakrishnan from '../assets/images/testmonial/jayakrishnan.png'
import fredaric from '../assets/images/testmonial/fredaric.png'
import prosenjith from '../assets/images/testmonial/prosenjith.png'
import parag from '../assets/images/testmonial/parag.png'

// client section
import client_1 from '../assets/images/client/cl_1.png'
import client_2 from '../assets/images/client/cl_2.png';
import client_3 from '../assets/images/client/cl_3.png';
import client_4 from '../assets/images/client/cl_4.png';
import client_5 from '../assets/images/client/cl_5.png';
import client_6 from '../assets/images/client/cl_6.png';
import client_7 from '../assets/images/client/cl_7.png';
import client_8 from '../assets/images/client/cl_8.png';
import client_9 from '../assets/images/client/cl_9.png';



export const projects = [
    {
        id : 1,
        name : 'EOT Camp Director App',
        path: project_2
    },
    {
        id : 2,
        name : 'EKA Portfolio App',
        path: project_4
    },
    {
        id : 3,
        name : 'EOT Staff Portfolio App',
        path: project_3
    },
    {
        id : 4,
        name : 'Oprex ELN App',
        path: project_12
    },
    {
        id : 5,
        name : 'Little Brahma Hire Designers App',
        path: project_1
    },
    {
        id : 6,
        name : 'Clear Subtitle Tool App',
        path: project_5
    },
    {
        id : 7,
        name : 'Alga Energy App',
        path: project_6
    },
    {
        id : 8,
        name : 'Pressure App Yokogawa',
        path: project_7
    },
    {
        id : 9,
        name : 'Twaddan Car Wash App',
        path: project_8
    },
    {
        id : 10,
        name : 'Groom HR Management App',
        path: project_9
    },
    {
        id : 11,
        name : 'Bigmenu Grocery App',
        path: project_10
    },
    {
        id : 12,
        name : 'Little Brahma E-Commerce App',
        path: project_11
    },
]

export const skills = [
    {
        id : 1, 
        name : "User-Centered Design (UCD) Process",
        percent: "90%"
    },
    {
        id : 2, 
        name : "Leadership, Mentoring & Collaboration",
        percent: "90%"
    },
    {
        id : 3, 
        name : "Wireframing, VD & Prototyping",
        percent: "90%"
    },
    {
        id : 4, 
        name : "Strategic Thinking and Problem Solving",
        percent: "90%"
    },
    
]

export const experience = [
    {
        id: 1,
        position: "User Experience Lead",
        year: "Aug 2022 - Present",
        company: "Optum , Bengaluru", 

    },
    {
        id: 2,
        position: "Senior UX Designer",
        year: "Aug 2019 - Aug 2022",
        company: "Yokogawa IA Technologies Pvt. Ltd, Bengaluru", 

    },
    {
        id: 3,
        position: "Senior UX Designer",
        year: "Sep 2017 - Aug 2019",
        company: "Prime Focus Technologies, Bengaluru", 

    },
    {
        id: 1,
        position: "Product Designer",
        year: "Nov 2014 - Feb 2017",
        company: "Invntree Pvt Ltd, Bengaluru", 

    },
    {
        id: 1,
        position: "Product Designer",
        year: "Jan 2009 - Aug 2012",
        company: "Luk India Pvt. Ltd, Hosur", 

    },
]

export const education = [
    {
        id: 1, 
        course: "M.sc - Product Design",
        univercity : "Coventry University United Kingdom Regular",
        year: "2012 - 2014",
        about: "Master Degree in Product Design covered areas such as user-centered design, Design management, Design Innovation, and Design technology."
    },
    {
        id: 2, 
        course: "M.B.A - Master of business administarion",
        univercity : "Indian School of Business Management",
        year: "2010 - 2012",
        about: "Master of Business Administration MBA graduated with expertise in strategic management, project leadership, and data analysis. Proven ability to drive results and contribute to organizational success through strong analytical and communication skills."
    },
   

]

export const awards = [
    {
        id: 1, 
        path: award_1
    },
    {
        id: 2, 
        path: award_2
    },
    {
        id: 3, 
        path: award_3
    },
    {
        id: 4, 
        path: award_4
    },
]

export const testimonial = [
    {
        id: 1,
        name : "Sonal Mehra",
        position: "Co-founder tawgl® | Interview Intelligence | Data-Driven Hiring | Championing Candidate Experience & Employer Branding",
        path: sonalmehra,
        linkedin: "https://www.linkedin.com/in/sonal-mehra-3744a15",
        about: "I've had the pleasure of working with Sainu as our freelance UI/UX designer, and I can confidently say he’s been a fantastic collaborator. He’s incredibly detail-oriented, often catching things the rest of us might overlook, and his ability to connect the dots across projects—even after gaps in time—is remarkable. One of the things I value most is his willingness to speak up and share his opinions. That openness leads to stronger discussions, better decisions, and ultimately, better outcomes. Working with him has been both productive and enjoyable, and I’m glad to have him on board.",
    },
    {
        id: 2,
        name : "Kartik Puttaiah",
        position: "Entrepreneur",
        path: kartik,
        linkedin: "https://www.linkedin.com/in/kartikputtaiah/",
        about: "I am greatly impressed and inspired by Sainudheen's professionalism and creativity. He takes complete ownership of the projects and drives the projects with sheer determination. He goes into great lengths to understand the business and user perspectives, which reflects in his UI and UX designs. His business acumen is complemented by his creativity, He activity contributes to the team with his valuable ideas and suggestions, making him an invaluable asset to the company!.",
    },
    {
        id: 3,
        name : "Pooja Haridas",
        position: "UX/UI Designer",
        path: pooja,
        linkedin: "https://www.linkedin.com/in/pooja-haridas-86540228/",
        about: "I had a chance to work with Sainudheen at the starting of my UX career journey.His approach to solving a problem diving deep into the complexities is highly commendable.He would always come up with multiple intuitive solutions for a single problem which used to be a great source to learn and understand.Sainudheen used to mentor and suggest ways in case of difficult tasks.A go to person for UX doubts. I highly recommend Sainudheen.",
    },
    {
        id: 4,
        name : "Jayakrishnan Krishnakumar",
        position: "UX Manager",
        path: jayakrishnan,
        linkedin: "https://www.linkedin.com/in/jayakrishnan-krishnakumar-314a6735/",
        about: "Sainu is very passionate in what he does. He is very Creative and Proactive in his field. Knowledge in UI and UX makes him one level above. His ideas can bring good changes to a product.",
    },
    {
        id: 5,
        name : "Fredaric Mathew Lal",
        position: "UX Lead @ Plansource | Previously with Deloitte, Yokogawa and a bunch of startups",
        path: fredaric,
        linkedin: "https://www.linkedin.com/in/fredarico/",
        about: "January 19, 2024, Fredaric worked with sainu on the same teamJanuary 19, 2024, Fredaric worked with sainu on the same team Worked with Sainu, in Yokogawa for a brief period of time. He was well versed in sketch and even though our industry was a bit unique, he was able to pick up the specifics fairly quickly.He is also a really social person and would gel into any team soon enough.",
    },
    {
        id: 6,
        name : "Prosenjit Das",
        position: "UX Design Leader, Strategist, Consultant",
        path: prosenjith,
        linkedin: "https://www.linkedin.com/in/prosenjit-das-a3ab3928/",
        about: "I worked closely with Sainu. He is very energetic, hard-working and goal oriented individual. He has good aesthetics and eye on details. He love to face new challenges and opportunities. He could be a great asset to any organization.",
    },
    {
        id: 7,
        name : "Parag Sarma",
        position: "UX Design Evangelist, Design Educator, Contemporary Media Artist",
        path: parag,
        linkedin: "https://www.linkedin.com/in/paragsarma/",
        about: "During my interaction with Sainu in Yokogawa, I personally unearthed many creative and meaningful approaches toward Design problems, he is the quick and most dedicated person that I have ever met in my professional journey. His input and suggestions have always brought productive outcomes in our collaborative projects. I wish him all the best for his future.",
    },
]

export const clients = [
    {
        id: 1,
        path: client_1,
    },
    {
        id: 2,
        path: client_2,
    },
    {
        id: 3,
        path: client_3,
    },
    {
        id: 4,
        path: client_4,
    },
    {
        id: 5,
        path: client_5,
    },
    {
        id: 6,
        path: client_6,
    },
    {
        id: 7,
        path: client_7,
    },
    {
        id: 8,
        path: client_8,
    },
    {
        id: 9,
        path: client_9,
    },
];